import { useEffect } from 'react';
import { startTour } from '../communication/startTour';
import { LOGGER_NAME, setupLogger } from '../logging/setupLogger';
import { Logger } from 'simple-logging-lib';
import { Party } from '../communication/sync.messages';
import { partyAlive } from '../communication/partyAlive';
import { useEffectOnce } from './useEffectOnce';
import { useMeasurePerformance } from './useMeasurePerformance';
export const useStartOnboardingTour = tour => {
  const {
    getDuration
  } = useMeasurePerformance();
  useEffectOnce(() => {
    setupLogger();
  });
  useEffect(() => {
    const unsubscribe = partyAlive(Party.APP_STARTING_TOUR, party => {
      if (party === Party.NAV_ONBOARDING_TOURS_CONSUMER) {
        startTour(tour, () => {
          const {
            startTime,
            endTime,
            durationMs
          } = getDuration();
          const logger = Logger.getLogger(LOGGER_NAME);
          logger.debug(`Onboarding tour started successfully: ${tour.tourId} (started at ${startTime}, took ${durationMs}ms, ended at ${endTime})`);
        });
      }
    });
    return () => {
      unsubscribe();
    };
  }, [tour, getDuration]);
};